import { useEffect, useState,useContext  } from "react";
import $ from "jquery";
import {
    useNavigate
  } from "react-router-dom";
import {Card,ListGroup,Button,Modal,Form, Accordion } from 'react-bootstrap';
import {BsFillPencilFill} from "react-icons/bs";
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import UserContext from "../../contexts/UserContext";

const EditMenu = () => {

const [menus,setMenus] = useState([]);
const [dates,setDates] = useState([]);
const {user,setUser} = useContext(UserContext);
const [value, setValue] = useState([]);
const [noMenuMessage, setNomenuMessage] = useState(false);
const [assurance, setAssurance] = useState(false);
const [currentDay, setCurrnentDay] = useState({});
const [currentDate, setCurrnentDate] = useState('');
const weekDays = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
const [isLoading, setLoading] = useState(true);
const handleClose = () => setAssurance(false);

const navigate = useNavigate();    
    
    const getUser = async (userId) => {
        await $.ajax({
            type:"GET",
            url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
            xhrFields: {
                withCredentials: true  // Include cookies
              },
              crossDomain: true, 
             success : async function(response){
              if(response && response.user){
                 await setUser(response.user);
              }else{
                setUser(null)
                navigate("/login")
              }
            },
            error: function(err){
                console.log("error")
                console.log(err)
            }
        })
    }

    const getData = async () => {
        await $.ajax({
            type:"GET",
            url:process.env.REACT_APP_API_URL+"/rsvps",
            xhrFields: {
                withCredentials: true  // Include cookies
              },
              crossDomain: true, 
             success : function(response){
              if(response.message  && response.message.includes("Error in auth")){
                navigate("/login",{state: { message: response.message }})
              }
              if(response.menuForRsvp.length>0){
                if(response.user && response.user.rsvpData){
                response.user.rsvpData.map((day)=>{
                    response.menuForRsvp.map((menu)=>{
                        if(menu.day === weekDays.indexOf(day.date.split(" ")[0])){
                            menu.items.map((item)=>{
                                if(day.menu.find(mItem=>mItem.name === item)){
                                    if(!menu.item){
                                        menu.item=[];
                                    }
                                    menu.item.push({name : item,
                                    value: day.menu.find(mItem=>mItem.name === item).value})
                                }
                            })
                        }
                    })
                })
                setUser(response.user)
            }
                setMenus(response.menuForRsvp)
                setDates(response.weekDates)
                setLoading(false);
              }else{
                setNomenuMessage(true);
                setLoading(false);
              }
              
            },
            error: function(err){
                console.log("error")
                console.log(err)
                navigate("/login")
            }
        })
    }

    const handleChange = (e,day,items) => {
        setValue((data)=>{
            return[
                ...data,{
                name:e.target.name,
                value:e.target.value
            }
            ]   
        });
    }

    const sure = (day,dates) => {
        setAssurance(true);
        setCurrnentDate('');
        setCurrnentDay({});
        setCurrnentDate(dates);
        setCurrnentDay(day);
    }

    const submitReq = async (day,dates) => {
        handleClose();
            setLoading(true);
        var finalArr =[];
        await currentDay.items.map(async (item)=>{
            var finalObj = {};
            await value.map((dabbaInfo)=>{
                if(item === dabbaInfo.name){
                    finalObj.name = dabbaInfo.name
                    finalObj.value = dabbaInfo.value
                }
            })
            finalArr.push(finalObj);
        })
        $.ajax({
            type:"POST",
            url:process.env.REACT_APP_API_URL+"/rsvp",
            data:{day:currentDay,dates:currentDate,finalArr},
            dataType: 'json',
            xhrFields: {
                withCredentials: true  // Include cookies
              },
              crossDomain: true, 
             success : function(response){
                if(response.message  && response.message.includes("Error in auth")){
                    setUser(null);
                    navigate("/login");
                  }
              if(response.message==="success"){
                getData();
              }    
              setLoading(false)
            },
            error: function(err){
                console.log("error")
                console.log(err)
                navigate("/rsvp")
                setLoading(false)
            }
        })
    }

    function getFractionValue(value){
        switch(value){
            case 0 : return "Not needed";
            case 0.25 : return "1/4 Dabba";
            case 0.5 : return "1/2 Dabba";
            case 0.75 : return "3/4 Dabba";
            case 1 : return "Full Dabba";
            default : return null;
        }
    }

    useEffect( () => {
        try{
        if(!user && localStorage.getItem('userSession')){
            getUser(JSON.parse(localStorage.getItem('userSession')))
          }else{
            if(!user){
              navigate("/login")
            }
          }
        }catch(e){
            if(!user){
                navigate("/login")
            }
        }
         getData();
      }, []);

    
    const design = (
        <>                  
        {noMenuMessage?<Alert key='danger' variant='danger'>The Dashboard will open once the menu is updated for next week !</Alert>:null}
 
            {
                menus.map((day,i)=>{
                    if(day.items.length && !day.items[0].label){
                    return <>
                        <Form className="mt-3">
                        <Card className="mb-4 mx-3">
                        <Card.Header >{dates[day.day]}</Card.Header>
                        {user && (user.rsvpData && !(user.rsvpData.find(datesn=>datesn.date === dates[day.day])))?(<ListGroup variant="flush">
                            {
                                day.items.map((items,i)=>{
                                        var menuItem = null;
                                        return <>
                                        <Accordion key={i}>
                                            <Accordion.Header>{items}</Accordion.Header>
                                            <Accordion.Body>
                                                <div >
                                                <div className="d-flex justify-content-around p-3">
                                                    <span style={{color:"#c38154"}}><input type="radio" name={items} value="0" onChange={(event)=>handleChange(event,day,items)} /> Not needed</span>
                                                    <span style={{color:"#c38154"}}><input type="radio" name={items} value="0.25" onChange={(event)=>handleChange(event,day,items)} /> 1/4 Dabba</span>
                                                </div>
                                                <div className="d-flex justify-content-around p-3">
                                                    <span style={{color:"#c38154"}}><input type="radio" name={items} value="0.5" onChange={(event)=>handleChange(event,day,items)} /> 1/2 Dabba</span>
                                                    <span style={{color:"#c38154"}}><input type="radio" name={items} value="0.75" onChange={(event)=>handleChange(event,day,items)} /> 3/4 Dabba</span>
                                                </div>
                                                <div className="d-flex justify-content-around p-3">
                                                    <span style={{color:"#c38154"}}><input type="radio" name={items} value="1" onChange={(event)=>handleChange(event,day,items)} /> Full Dabba</span>
                                                </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion>
                                            
                                        </>
                                })
                            }
                        </ListGroup>):null}
                            {user && (user.rsvpData && !(user.rsvpData.find(datesn=>datesn.date === dates[day.day])))
                            ?<Card.Link onClick={()=>{sure(day,dates[day.day])}} href="#" className="m-2 svg-color"><BsFillPencilFill className="ms-2 svg-color"/> Submit Filling Request</Card.Link>
                            :<div>
                                <p className="m-2">{user.rsvpData?user.rsvpData.find(datesn=>datesn.date === dates[day.day]).menu.map((items)=> <p>{items.name} : {getFractionValue(items.value)} </p>):null} </p>
                            </div>}
                        </Card>
                        </Form>
                        <Modal show={assurance} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Submit</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        You will be able to submit requirement only once...Are you sure you want to submit
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button variant="primary" onClick={submitReq}>
                                Okay
                            </Button>
                            </Modal.Footer>
                        </Modal>
                    </>}
                })
                }
        </>
    )
    return isLoading? <div className="mx-auto mt-5" style={{width: "30px"}}><Spinner className="mx-auto " style={{color:'brown'}} animation="border" role="status">
    </Spinner><br/>
    <span style={{marginLeft:'-10px'}}>Loading...</span></div>: design;
}

export default EditMenu;